import { useState } from "react";
import { useSeason } from "../../context/SeasonContext";
import { getCaseArtwork } from "./caseArtwork";
import styles from "./CaseArtwork.module.css";

export function CaseArtwork({ caseItem, className = "" }) {
  const { season } = useSeason();
  const [failedSrc, setFailedSrc] = useState(null);
  const artwork = getCaseArtwork(caseItem, season);
  const Icon = artwork?.Icon;
  const kind = Icon ? "thematic" : artwork?.src ? "brand" : "placeholder";

  return (
    <span
      className={`${styles.artwork} ${styles[kind]} ${styles[artwork?.tone] || ""} ${className}`}
      data-case-artwork={artwork?.asset}
      aria-hidden="true"
    >
      {Icon ? <Icon className={styles.symbol} /> : artwork?.src && (
        failedSrc === artwork.src ? caseItem.project_code : (
          <img
            src={artwork.src}
            alt=""
            className={styles.image}
            loading="lazy"
            decoding="async"
            onError={() => setFailedSrc(artwork.src)}
          />
        )
      )}
    </span>
  );
}
